module.exports = __webpack_public_path__ + "static/media/distributions3.91f5e6d7.gif";